import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'

export class LeadsService extends BaseService {
  static async getListLeads(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-list-web'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListOwner(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-list-4-wk'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListOwner(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-list-4-wk'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async assignActiveSale(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.sale-assign'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async assignTeleSale(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.tele-sale-assign'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailLead(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-info-by-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async channelSource(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.data-source'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async authLead(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.redirect-to-verify'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async registerLead(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.register'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateLead(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async completeConvertToCustomer(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.verify'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateWrongInfo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.update-wrong-stt'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateDuplicateInfo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.update-duplicate-stt'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createAction(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.action-create'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importLeadByExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.import-data'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async historyUpload(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.history-import-lead'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileTemplate(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.import-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      console.log(response)
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Import_Leads_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Export_Leads' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async assignCaringSale(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.sale-assign'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // lịch sử chăm sóc
  static async careHistory(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-action-by-lead-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async mcTaskNotProcess(searchId) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.list-task-not-process'),
        { searchId }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async mcTaskProcessed(searchId) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.list-task-processed'),
        { searchId }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // management-shipping
  static async getDeviceByAgentId(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.shipping.device-serials-vcbho'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateInforShippping(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.change-shipping-info'),
        body
      )
      console.log('call telesale update infor')

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListLeadShipping(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.shipping.list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailShippingInfor(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.shipping.info'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportDataShipping(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.shipping.export-data'),
        body,
        {
          responseType: 'blob',
        }
      )
      FileDownload(response.data, 'Danh sách thông tin giao hàng.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async setApprovedShipping(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.shipping.approved'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateStatusShipping(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.shipping.change-shipping-status'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateInforShipppingByManagementTele(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl(
          'cnps.lead.shipping.update-form-shipping-info-after-change-shipping-status'
        ),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
